import { useState } from "react";
import { toast } from "react-hot-toast";
import { useConnection } from "../../hooks/useConnection";
import Input from "../Input/Input";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import styles from "./Newsletter.module.scss";


const Newsletter = () => {
  const [form, setForm] = useState({
    email: "",
    loader: false,
  });
  const connection = useConnection();

  const validarEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  };

  async function newsLetter(e) {
    e.preventDefault();

    if (!validarEmail(form.email)) {
      toast.error("Ingresá un correo electrónico válido");
      return;
    }

    setForm((prev) => ({ ...prev, loader: true }));

    try {
      const res = await connection({
        url: "/newsletter/custom/subscribe",
        method: "POST",
        body: { email: form.email },
      });

      if (res.statusCode === 200) {
        toast.success("¡Te suscribiste correctamente! 🎉");
        setForm({ email: "", loader: false });
      } else {
        toast.error("Hubo un problema al suscribirte 😕");
        setForm((prev) => ({ ...prev, loader: false }));
      }
    } catch (err) {
      toast.error("Error de conexión. Intentalo más tarde 🚫");
      console.log("Error al suscribirse:", err.message);
      setForm((prev) => ({ ...prev, loader: false }));
    }
  }

  return (
    <section className={styles.newsletter}>
      <div className={styles.grid}>
        <div className={styles.text}>
          <h6>Entérate antes que nadie.</h6>
          <p>
            Únete a nuestro <strong>Newsletter</strong> y sé el primero en
            enterarte de ofertas exclusivas, lo mejor en eventos en vivo y mucho
            más.
          </p>
        </div>

        <form className={styles.form} onSubmit={newsLetter}>
          <Input
            id="email"
            type="email"
            placeholder="Email"
            autoComplete="email"
            required
            inputMode="email"
            value={form.email}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, email: e.target.value }))
            }
          />

          <PrimaryButton className={styles.button} type="submit" fontWeight="700" loading={form.loader}>
            Suscribirme
          </PrimaryButton>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
